import { Box, Heading, Grid, GridItem, useStyleConfig } from '@chakra-ui/react';
import LoadingPage from './LoadingPage';

////Needs to be formatted/styled
const ErrorPage = ({dataError}) => {

  const variant='wrapper';
  const styles = useStyleConfig('ErrorPage',{variant});
  if (dataError === null || dataError === '') {
    return <LoadingPage />;
  } else {
    return (
      <Box __css={styles}>
        <Box sx={{ ...styles.logo }}>
          <Grid templateColumns="repeat(10, 1fr)" sx={{ ...styles.logo.grid }}>
            <GridItem sx={{ ...styles.logo.grid.gridItem }} key="logo">
              <img
                src="/app/images/RS-logo.png"
                alt="RS Works Logo"
                sx={{ ...styles.logo.grid.gridItem.img }}
              />
            </GridItem>
          </Grid>
        </Box>
        <Box sx={{ ...styles.error }}>
          <Box sx={{ ...styles.error.header }}>
            <Heading variant="h1">Error</Heading>
          </Box>
          <Box sx={{ ...styles.error.content }}>
            <h2>
              There was a loading issue. <br />
              Please try again later.
            </h2>
          </Box>
        </Box>
      </Box>
    );
  }
};

export default ErrorPage;
